export enum EnumMenuPrincipalModelo{
    Completo = 'Completo',
    Mini = 'Mini'
}
